<template>
    <a-descriptions size="small" bordered>
      <a-descriptions-item :label="ve.label" v-for="ve in valoresExpandidos">
        <slot :name="ve.column" :item="detalle[ve.column]">
        {{detalle[ve.column]}}
        </slot>
      </a-descriptions-item>
      <slot name="items"></slot>
    </a-descriptions>
</template>

<script>
    export default {
      props: {
        detalle: {
          type: Object
        },
        valoresExpandidos: {
          type: Array
        }
      }
    }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/components/ui/DescriptionsDetail.vue